import { Input, type InputProps } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import * as React from "react";
import RPNInput, {
  type Props as RPNProps,
  type Value,
} from "react-phone-number-input/input";

type PhoneInputProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
> &
  Omit<RPNProps<InputProps>, "onChange"> & {
    onChange?: (value: Value) => void;
    value?: Value;
  };

export const PhoneInput: React.ForwardRefExoticComponent<PhoneInputProps> =
  React.forwardRef<React.ElementRef<typeof RPNInput>, PhoneInputProps>(
    ({ className, onChange, ...props }, ref) => {
      const handleChange = React.useCallback(
        (value: Value) => {
          onChange?.(value as Value);
        },
        [onChange],
      );
      return (
        <RPNInput
          ref={ref}
          className={cn("flex", className)}
          inputComponent={Input}
          onChange={handleChange}
          {...props}
        />
      );
    },
  );
PhoneInput.displayName = "PhoneInput";
